import { TypedDocumentNode, gql } from '@apollo/client';

import { Position, Sport } from '@sorare/core/src/__generated__/globalTypes';
import useQuery from '@sorare/core/src/hooks/graphql/useQuery';

import {
  PreFetchSo5BenchMarketplaceQuery,
  PreFetchSo5BenchMarketplaceQueryVariables,
} from './__generated__/usePreFetchSo5BenchMarketplaceQuery.graphql';

const PRE_FETCH_SO5_BENCH_MARKETPLACE_QUERY = gql`
  query PreFetchSo5BenchMarketplaceQuery(
    $so5LeagueSlug: String!
    $positions: [Position!]!
    $sport: Sport!
  ) {
    so5 {
      so5League(slug: $so5LeagueSlug) {
        slug
        topRecommendations(
          recommendationEngine: POPULAR_OR_HOT_STREAK
          positions: $positions
          sport: $sport
        ) {
          id
          playerSlug
          anyPlayer {
            slug
            displayName
          }
        }
      }
    }
  }
` as TypedDocumentNode<
  PreFetchSo5BenchMarketplaceQuery,
  PreFetchSo5BenchMarketplaceQueryVariables
>;

type Props = {
  so5LeagueSlug: string;
  positions: Position[];
  sport: Sport;
  skip?: boolean;
  excludedPlayersSlugs: string[];
};

export const usePreFetchSo5BenchMarketplaceQuery = ({
  positions,
  so5LeagueSlug,
  sport,
  skip,
  excludedPlayersSlugs,
}: Props) => {
  const { data, loading } = useQuery(PRE_FETCH_SO5_BENCH_MARKETPLACE_QUERY, {
    variables: {
      positions,
      so5LeagueSlug,
      sport,
    },
    skip,
  });

  const hasDisplayableResults =
    !loading &&
    !!data?.so5.so5League?.topRecommendations.length &&
    !!data.so5.so5League.topRecommendations.filter(
      recommendation =>
        !excludedPlayersSlugs?.includes(recommendation.anyPlayer.slug)
    ).length;

  return {
    hasDisplayableResults,
  };
};
